import { useNativeTab } from './NativeTabContext';
import { useLang } from '../context/LanguageContext';
import './NativeHeader.css';

export default function NativeHeader({ onOpenSearch }) {
  const { t } = useLang();
  const { setTab } = useNativeTab();

  return (
    <header className="rk-top" id="site-header-nav">
      <div className="rk-top__bar">
        <span className="rk-top__spacer" aria-hidden />
        <button type="button" className="rk-top__logo" onClick={() => setTab('home')} aria-label={t.brandName}>
          <img src="/rk-logo.webp" alt="" />
        </button>
        <button type="button" className="rk-top__search" onClick={onOpenSearch} aria-label={t.nativeSearch}>
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-3.5-3.5" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </header>
  );
}
